// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3G99Q","footer":"ChangeClinic_footer__GOUtI"};